export const EPartnerInformationSection = {
  ADDITIONAL_OWNER: "additional_owner",
  PARTNER_ONBOARDING: "partner_onboarding",
} as const;

export type TPartnerInformationSection =
  (typeof EPartnerInformationSection)[keyof typeof EPartnerInformationSection];
